import Customers          from "../../../../domain/customer/Customers";
import MailGroups         from "../../../../domain/mail/group/MailGroups";
import MailSend           from "../../../../domain/mail/send/MailSend";
import MailSendContent    from "../../../../domain/mail/send/MailSendContent";
import MailSendRepository from "../../../../domain/mail/send/MailSendRepository";
import MailSendSubject    from "../../../../domain/mail/send/MailSendSubject";
import { ApiClient }      from "../../../configure/ApiClientConfig";
import {
  setMailSendAction,
  setMailSendContentAction,
  setMailSendCustomersAction,
  setMailSendGroupsAction,
  setMailSendSubjectAction
}                         from "../../../redux/mail/send/MailSendAction";

class MailSendDataSource implements MailSendRepository {
  constructor(private readonly dispatch) {
  }

  getCount() {
    return ApiClient.get("/mail/limit");
  }

  send(mailSend: MailSend) {
    return ApiClient.post("/mail/send", {
      mailGroupIds: mailSend.mailGroups.toList().map(mailGroup => mailGroup.id.value),
      customerIds: mailSend.customers.toList().map(customer => customer.id.value),
      subject: mailSend.subject.value,
      content: mailSend.content.value,
    });
  }

  setMailSend(mailSend: MailSend) {
    this.dispatch(setMailSendAction(mailSend));
  }

  setMailSendGroups(mailGroups: MailGroups) {
    this.dispatch(setMailSendGroupsAction(mailGroups));
  }

  setMailSendCustomers(customers: Customers) {
    this.dispatch(setMailSendCustomersAction(customers));
  }

  setMailSendSubject(mailSendSubject: MailSendSubject) {
    this.dispatch(setMailSendSubjectAction(mailSendSubject));
  }

  setMailSendContent(mailSendContent: MailSendContent) {
    this.dispatch(setMailSendContentAction(mailSendContent));
  }
}

export default MailSendDataSource;
